import {
  Card,
  FormLayout,
  Layout,
  Loading, SkeletonBodyText,
  SkeletonDisplayText,
  SkeletonPage,
  TextContainer
} from "@shopify/polaris";
import { CsI18n } from "../../shared/csI18n/csI18n";
import React from "react";

const SRSkeleton = () => {
  return (
    <SkeletonPage title={CsI18n.t("Shipping policy")} fullWidth>
      <Loading />
      <Layout>
        <Layout.AnnotatedSection title={CsI18n.t('shipping.annotate.title.product')}
                                 description={CsI18n.t('shipping.annotate.desc.product')}>
          <Layout.Section>
            <Card sectioned>
              <FormLayout>
                <TextContainer>
                  <SkeletonDisplayText size={"medium"} />
                  <SkeletonBodyText lines={3} />
                </TextContainer>
              </FormLayout>
            </Card>
          </Layout.Section>
        </Layout.AnnotatedSection>

        <Layout.AnnotatedSection title={CsI18n.t("return.annotate.title.payment")}
                                 description={CsI18n.t('return.annotate.desc.payment')}>
          <Layout.Section>
            <Card sectioned>
              <FormLayout>
                <TextContainer>
                  <SkeletonDisplayText size={"medium"} />
                  <SkeletonBodyText lines={3} />
                </TextContainer>
              </FormLayout>
            </Card>
          </Layout.Section>
        </Layout.AnnotatedSection>

        <Layout.AnnotatedSection title={CsI18n.t("shipping.annotate.title.carriers")}
                                 description={CsI18n.t('shipping.annotate.desc.carriers')}>
          <Layout.Section>
            <Card sectioned>
              <FormLayout>
                <TextContainer>
                  <SkeletonDisplayText size={"medium"} />
                  <SkeletonBodyText lines={6} />
                </TextContainer>
              </FormLayout>
            </Card>
          </Layout.Section>
        </Layout.AnnotatedSection>

        <Layout.AnnotatedSection title={CsI18n.t("return.annotate.title.returns")}
                                 description={CsI18n.t('return.annotate.desc.returns')}>
          <Layout.Section>
            <Card sectioned>
              <FormLayout>
                <TextContainer>
                  <SkeletonDisplayText size={"medium"} />
                  <SkeletonBodyText lines={6} />
                </TextContainer>
              </FormLayout>
            </Card>
          </Layout.Section>
        </Layout.AnnotatedSection>
      </Layout>
    </SkeletonPage>
  );
};

export default SRSkeleton;